/* eslint-disable no-console */
import { Injectable, inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { NzMessageService } from 'ng-zorro-antd/message';
import * as Sentry from '@sentry/angular-ivy';

@Injectable({
  providedIn: 'root',
})
export class LoggingService {
  private readonly logging: number;
  public readonly internalLogs: { date: Date; level: string; value: unknown; stack: string | undefined }[] = [];

  constructor() {
    switch (environment.logging) {
      case 'error':
        this.logging = 1;
        break;
      case 'warn':
        this.logging = 2;
        break;
      case 'info':
        this.logging = 3;
        break;
      default:
        this.logging = 4;
    }
  }

  private logCaller(level: string, ...args: unknown[]): void {
    const err = new Error(level);
    if (Error.captureStackTrace) {
      Error.captureStackTrace(err);
      console.log(err);
    } else {
      const stack = new Error().stack;
      console.log(stack);
      err.stack = stack;
    }
    this.internalLogs.push({ date: new Date(), level: level, value: args, stack: level === 'error' ? err.stack : '' });
  }

  public debug(...args: unknown[]): void {
    if (this.logging === 4) {
      console.log(args);
      this.logCaller('debug', args);
    }
  }

  public info(...args: unknown[]): void {
    if (this.logging >= 3) {
      console.log(args);
      this.logCaller('info', args);
    }
  }

  public warn(...args: unknown[]): void {
    if (this.logging >= 2) {
      console.warn(args);
      this.logCaller('warn', args);
    }
  }

  public error(...args: unknown[]): void {
    console.error(args);
    this.logCaller('error', args);

    Sentry.captureException(args[0], {
      tags: {
        online: navigator.onLine,
        version: environment.version,
      },
    });

    this.messageService.create('error', (args[0] as Error).message, {
      nzDuration: 8000,
      nzPauseOnHover: true,
    });
  }

  private readonly messageService = inject(NzMessageService);
}
